export default __webpack_public_path__ + "static/media/payment-history-grey.837d629a.svg";